import React from "react";
import PropTypes from "prop-types";
import styles from "./GroupPluginItem.module.css";
import Link from "shared/Link";
import classNames from "classnames";
import Button from "shared/Button";

/**
 * Interactive component.
 * Displays information about a group plugin in the GroupPluginList.
 */
export function GroupPluginItem({
  pluginInfo,
  onClick,
  onTargetClick,
  onPlugeeClick,
}) {
  //To capitalized the first letter only
  function titleCase(pluginInfo) {
    const titleCase = pluginInfo
      .toLowerCase()
      .split(" ")
      .map((info) => {
        return info.charAt(0).toUpperCase() + info.slice(1);
      })
      .join(" ");

    return titleCase;
  }

  return (
    <div className={styles.container}>
      <div className={styles.item}>
        <Link to={`/membership/lookup/ibo/${pluginInfo.plugeeIBONumber}`}>
          {pluginInfo.plugeeIBONumber}
        </Link>
      </div>
      <div className={styles.item}>
        {titleCase(pluginInfo.plugeeName)} {pluginInfo.plugeeBusinessType}
      </div>
      <div className={styles.item}>
        <Link to={`/membership/lookup/ibo/${pluginInfo.targetIBONumber}`}>
          {pluginInfo.targetIBONumber}
        </Link>
      </div>
      <div className={classNames(styles.item, styles.itemGroup)}>
        {pluginInfo.targetOrganizationName} &gt;
        <span className={styles.itemGroupName}>
          {titleCase(pluginInfo.targetGroupName)}
        </span>
      </div>
      <div className={styles.item}>{pluginInfo.asAdmin ? "Yes" : "No"}</div>
      <div className={styles.item}>
        <Button className={styles.detailsBtn} onClick={onClick} size="small">
          Details
        </Button>
      </div>
    </div>
  );

  /*
  const properties = {
    iboNumber: pluginInfo.iboNumber,
    ibo: pluginInfo.iboName,
    group: pluginInfo.groupName,
    admin: String(pluginInfo.asAdmin),
  };

  return (
    <li className={styles.container}>
      {Object.entries(properties).map((pair) => (
        <p className={styles[pair[0]]}>
          <span
            onClick={
              pair[0] === "ibo"
                ? onIboClick
                : pair[0] === "group"
                ? onGroupClick
                : null
            }
          >
            {String(pair[1])}
          </span>
        </p>
      ))}
      <Button
        type="button"
        className={styles.details}
        onClick={onClick}
        children={"Details"}
      />
    </li>
  );
  */
}

GroupPluginItem.propTypes = {
  /**
   * Object with the plugin info.
   */
  pluginInfo: PropTypes.shape({
    id: PropTypes.string,
    iboNumber: PropTypes.number,
    iboName: PropTypes.string,
    groupName: PropTypes.string,
    asAdmin: PropTypes.bool,
    date: PropTypes.string,
    time: PropTypes.string,
  }),
  /**
   * Function called when details is clicked.
   */
  onClick: PropTypes.func,
  /**
   * Function called when the IBO name is clicked.
   */
  onIboClick: PropTypes.func,
  /**
   * Function called when the group name is clicked.
   */
  onGroupClick: PropTypes.func,
};
